<template>
    <div class="content">
        <div v-if="org"  :style="`width:${width}px;background-color: white;border-radius:${body.borderradius}px`">
            <div   v-for="(d,i) in blocks" :key="i"  >
                <!--HEADER-->
                <Header v-if="d.type==='header'" :d="d"  :bodypadding="body.bodypadding" />
                <!--EDIT BLOCKS TEXT-->
                <BText v-if="d.type==='text'" :d="d"  :bodypadding="body.bodypadding"  />
                <!--EDIT BLOCKS BOXED-TEXT-->
                <BoxedText v-if="d.type==='boxed text'" :d="d"  :bodypadding="body.bodypadding"   />
                <!--EDIT BLOCKS IMAGE-->
                <BImage v-if="d.type==='image'" :d="d"  :bodypadding=" body.bodypadding"   />
                <!--BUTTON-->
                <BButton v-if="d.type==='button'" :d="d"  :bodypadding="body.bodypadding"   />
                <!--SPACER-->
                <Spacer v-if="d.type==='spacer'" :d="d"  :bodypadding=" body.bodypadding"   />
                <!--SOCIAL-->
                <Social v-if="d.type==='social'" :d="d"   :bodypadding="body.bodypadding"   />
                <!--FOOTER-->
                <BFooter v-if="d.type==='footer'" :d="d"   :bodypadding="body.bodypadding"  />
                <!--END EDIT BLOCKS-->
            </div>
        </div>
    </div>
</template>

<script>
  import {
    mapState
  }  from 'vuex'
  import Social from "./blocks/Social";
  import Header from "./blocks/Header";
  import BText from "./blocks/Text";
  import BoxedText from "./blocks/BoxedText";
  import BImage from "./blocks/BImage";
  import BButton from "./blocks/Button";
  import Spacer from "./blocks/Spacer";
  import BFooter from "./blocks/BFooter";
  export default {
    components: {BFooter, Spacer, BButton, BImage, BoxedText, BText, Header, Social},
    props:['blocks','width','body'],
    name: "EmailPreview",
    data() {
      return {
        socialicons:{
          twitter:'mdi-twitter-box',
          youtube:'mdi-youtube',
          facebook:'mdi-facebook-box',
          instagram:'mdi-instagram',
          linkedin:'mdi-linkedin-box',
          pinterest:'mdi-pinterest-box'
        },
      }
    },
    computed:{
      ...mapState(['org'])
    }
  }
</script>

<style scoped>
    .content {
        position: inherit;
        border-radius: 5px;
        display: flex;
        justify-content: space-around;
        flex-flow: row wrap;
        align-items: stretch;
        border: dashed thin #8888ff;
    }
    /*used in content block to handle activeevents*/
    .flexbox {
        position: relative;
        flex-grow: 1;
        min-height: 50px;
    }
</style>